import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementEmailTemplate.DeleteAttachment.IRequest;
type Response = Api.Core.ProviderStatementEmailTemplate.DeleteAttachment.IResponse;
type Headers = Api.Core.ProviderStatementEmailTemplate.DeleteAttachment.IHeaders;
const apiProviderStatementEmailTemplateDeleteAttachmentPath =
  '/api/Management/ProviderStatementEmailTemplate/:id/DeleteAttachment/:fileId';
export default async function providerStatementEmailTemplateDeleteAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiProviderStatementEmailTemplateDeleteAttachmentPath, { id, fileId: request.fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
